/* Generated file. Do not modify. */
import { createElement } from 'react';
import { IconWrapper } from '../IconWrapper';
import type { IconWrapperProps } from '../IconWrapper';
export default (props: IconWrapperProps) =>
  createElement(
    IconWrapper,
    props,
    <path
      fill="currentColor"
      d="M9.404 21.84c-.528 0-1.112-.048-1.752-.144-.624-.08-1.12-.176-1.488-.288v-2.016c.704.224 1.48.336 2.328.336 1.04 0 1.936-.168 2.688-.504.768-.336 1.352-.8 1.752-1.392.4-.592.6-1.248.6-1.968 0-1.968-1.12-3.016-3.36-3.144l-1.392.36-.528-1.608c.576-.08 1.224-.28 1.944-.6.88-.416 1.544-.92 1.992-1.512.464-.592.696-1.224.696-1.896 0-.72-.232-1.248-.696-1.584-.464-.352-1.04-.528-1.728-.528-.704 0-1.352.12-1.944.36a5.166 5.166 0 0 0-1.464.84l-.96-1.68c.288-.272.728-.56 1.32-.864.608-.32 1.288-.584 2.04-.792a8.194 8.194 0 0 1 2.304-.336c1.584 0 2.864.328 3.84.984.976.656 1.464 1.64 1.464 2.952 0 1.168-.448 2.176-1.344 3.024-.88.848-1.992 1.512-3.336 1.992.176-.016.424-.024.744-.024 1.44 0 2.608.36 3.504 1.08.896.704 1.344 1.672 1.344 2.904 0 1.136-.344 2.16-1.032 3.072-.688.928-1.68 1.656-2.976 2.184-1.296.528-2.816.792-4.56.792Z"
    />
  );
